import { callAPI } from "../../network/networkConnection";

const uploadSkuList = (formData) => {
  return new Promise((resolve, reject) => {
    callAPI(
      process.env.REACT_APP_APIUrl + "admin/sku-upload",
      "POST",
      {},
      formData
    )
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

const getSkuUploadProgress = (jobId) => {
  return callAPI(
    process.env.REACT_APP_APIUrl + `admin/sku-upload/progress/${jobId}`,
    "GET",
    { "Content-Type": "application/json" },
    null
  );
};

const getSkuUploadJobs = () => {
  return callAPI(
    process.env.REACT_APP_APIUrl + "admin/sku-upload/jobs",
    "GET",
    { "Content-Type": "application/json" },
    null
  );
};

const uploadSkuListGlobalSearch = (formData) => {
  return new Promise((resolve, reject) => {
    callAPI(
      process.env.REACT_APP_APIUrl + "admin/sku-upload/global-search",
      "POST",
      {},
      formData
    )
      .then((res) => resolve(res))
      .catch((err) => reject(err));
  });
};

const cancelSkuJob = (jobId) => {
  return callAPI(
    process.env.REACT_APP_APIUrl + `admin/sku-upload/cancel/${jobId}`,
    "POST",
    { "Content-Type": "application/json" },
    null
  );
};

// Generic HTTP methods
const get = (endpoint, params = {}) => {
  const queryString = Object.keys(params).length ? 
    '?' + new URLSearchParams(params).toString() : '';
  return callAPI(
    process.env.REACT_APP_APIUrl + "admin" + endpoint + queryString,
    "GET",
    { "Content-Type": "application/json" },
    null
  );
};

const post = (endpoint, payload) => {
  return callAPI(
    process.env.REACT_APP_APIUrl + "admin" + endpoint,
    "POST",
    { "Content-Type": "application/json" },
    JSON.stringify(payload)
  );
};

const put = (endpoint, payload) => {
  return callAPI(
    process.env.REACT_APP_APIUrl + "admin" + endpoint,
    "PUT",
    { "Content-Type": "application/json" },
    JSON.stringify(payload)
  );
};

const patch = (endpoint, payload = {}) => {
  return callAPI(
    process.env.REACT_APP_APIUrl + "admin" + endpoint,
    "PATCH",
    { "Content-Type": "application/json" },
    JSON.stringify(payload)
  );
};

const deleteRequest = (endpoint) => {
  return callAPI(
    process.env.REACT_APP_APIUrl + "admin" + endpoint,
    "DELETE",
    {},
    {}
  );
};

// Legacy pricing algo methods
const getPricingAlgo = () => {
  return callAPI(
    process.env.REACT_APP_APIUrl + "admin/pricing-algo",
    "GET",
    {},
    {}
  );
};

const updatePricingAlgo = (payload) => {
  return callAPI(
    process.env.REACT_APP_APIUrl + "admin/pricing-algo",
    "PUT",
    {},
    payload
  );
};

// Amazon Product scraping
const getAmazonProductByAsin = (asin) => {
  return callAPI(
    process.env.REACT_APP_APIUrl + `admin/amazon-product/${asin}`,
    "GET",
    { "Content-Type": "application/json" },
    null
  );
};

// Bulk Product Details
const getProductErrorsBulkDetails = (productIds) => {
  return post("/product-errors/bulk-details", { productIds });
};

export const adminApiService = {
  uploadSkuList,
  uploadSkuListGlobalSearch,
  getSkuUploadProgress,
  getSkuUploadJobs,
  cancelSkuJob,
  getPricingAlgo,
  updatePricingAlgo,
  getAmazonProductByAsin,
  getProductErrorsBulkDetails,
  get,
  post,
  put,
  patch,
  delete: deleteRequest,
};